module.exports = __webpack_public_path__ + "img/logo_white.2f07a06a.png";